<template>
  <div class="book-calender-container">
    <div class="book-days">
      <div class="book-day"
           v-for="(item, index) in dayList"
           @click="selectItem(item, index, $event)"
           :key="index"
           :class="{selected: select === index, available: item.available}">
        <div class="week-status">
          <span class="date-day">{{ item.day }}</span>
          <span class="date-week">{{ item.week }}</span>
        </div>
        <div class="book-status" v-if="item.available">
          <span v-if="select !== index && !bookNumber">
            {{ item.available ? '有' : '*—*'}}
          </span>
          <span v-else-if="bookNumber && select === index">
            {{ bookNumber }}
          </span>
          <span v-else>有</span>
        </div>
        <div class="book-status" v-else>
          <span>
            *—*
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'BookCalender',
  props: ['current', 'serviceTime', 'bookNumber', 'dayList', 'select'],
  data() {
    return {
      availableDays: 3,
      currentDate: undefined,
    };
  },
  mounted() {
    console.log(this.dayList);
    this.currentDate = moment(this.current); // 当前日期
  },
  methods: {
    selectItem(item, index) {
      if (item.available) {
        this.$emit('change', index);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.book-calender-container {
  .book-days {
    display: flex;
    flex-direction: row;
    -ms-flex-direction: row;
    -webkit-flex-direction: row;
    padding-bottom: 4px;
    padding-top: 4px;
    .book-day {
      flex-basis: 0;
      flex-grow: 1;
      color: #cccccc;
      background-color: #fff;
      box-sizing: border-box;
      padding-top: 3px;
      margin-right: 2px;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      &.available {
        color: rgba(#333333, 0.8);
      }
      &.selected {
        color: rgba(#990033, 0.7);
      }
      .week-status {
        padding-left: 2px;
        padding-bottom: 4px;
      }
      .date-day {
        font-size: 15px;
        margin-right: 2px;
      }
      .date-week {
        display: inline-block;
        font-size: 12px;
        transform: scale(0.75);
      }
      .book-status {
        font-family: Sans-serif;
        height: 1.214rem;
        width: 100%;
        padding: 4px 0;
        text-align: center;
        font-size: 12px;
        color: #cccccc;
      }
      &.selected {
        .book-status {
          color: #fff;
          background-color: #990033;
          border-bottom-left-radius: 4px;
          border-bottom-right-radius: 4px;
          box-shadow: 0 2px 2px 1px rgba(0, 0, 0, 0.2);
          transition: all .3s;
        }
      }
    }
  }
}
</style>
